// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uYFI","rootMobile":"styles_rootMobile__22D_i"};